import {BasicListReducerStateType} from "../BasicReducerState";
import {IProjectLogEntry} from "../../models/projects/ProjectLog";
import {
    FETCH_INCOMING_INVOICES_PROJECT_LOG,
    FETCH_INCOMING_INVOICES_PROJECT_LOG_ERROR,
    FETCH_INCOMING_INVOICES_PROJECT_LOG_SUCCESS,
    IncomingInvoiceProjectLogViewActionTypes
} from "../../actions/incoming-invoice/IncomingInvoiceProjectLogActions";
import {
    errorFetchingRequestState, RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";


export interface IncomingInvoiceProjectLogState {
    entries: {
        [ key: number ]: {
            totalEntries: number
            current: IProjectLogEntry[]
            request: RequestState
        }
    }

}

const initialState: IncomingInvoiceProjectLogState = {
    entries: {}
};

export function IncomingInvoiceProjectLogReducer(
    state: IncomingInvoiceProjectLogState = initialState,
    action: IncomingInvoiceProjectLogViewActionTypes
) {

    switch( action.type ) {
        case FETCH_INCOMING_INVOICES_PROJECT_LOG:
            return {
                ...state,
                entries: {
                    [ action.invoiceId.rawValue ]: {
                        totalEntries: 0,
                        current: [],
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_INCOMING_INVOICES_PROJECT_LOG_SUCCESS:
            return {
                entries: {
                    ...state.entries,
                    [ action.invoiceId.rawValue ]: {
                        totalEntries: action.payload.totalEntries,
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_INCOMING_INVOICES_PROJECT_LOG_ERROR:
            return {
                entries: {
                    ...state.entries,
                    [ action.invoiceId.rawValue ]: {
                        totalEntries: 0,
                        current: [],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        default:
            return state;
    }

}